import { getBillingEngines } from "@Api/BillingEngine";
import Button from "@Components/Button";
import Form, { InputType } from "@Components/Form";
import { validation } from "@Shared/Validate";
import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
export function Auto(props) {
    const [billingEngines, setBillingEngines] = useState([]);
    const init = async () => {
        let engines = await getBillingEngines();
        engines = engines
            .filter((platform) => platform.engine !== 0)
            .map((platform) => {
            return {
                value: platform.engine,
                label: (React.createElement("div", null,
                    React.createElement("img", { src: platform.icon, className: styles.billingEngineIcon }),
                    platform.name)),
            };
        });
        setBillingEngines(engines);
    };
    useEffect(() => {
        init();
    }, []);
    const [data, setData] = useState({});
    const [errors, setErrors] = useState({});
    const submitPlatform = () => {
        try {
            validation(data, {
                username: {
                    presence: true,
                    type: "string",
                    length: {
                        minimum: 1,
                    },
                },
                password: {
                    presence: true,
                    type: "string",
                    length: {
                        minimum: 1,
                    },
                },
                platform: {
                    presence: true,
                },
            });
            props.submit(data);
        }
        catch (error) {
            setErrors(error.fails);
        }
    };
    return (React.createElement("div", { className: styles.card },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.titleContainer },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
                        React.createElement("g", { "clip-path": "url(#clip0_6578_5962)" },
                            React.createElement("path", { d: "M2.99967 14.6663V11.333M2.99967 4.66634V1.33301M1.33301 2.99967H4.66634M1.33301 12.9997H4.66634M8.66634 1.99967L7.51022 5.00558C7.32221 5.4944 7.22821 5.73881 7.08203 5.9444C6.95247 6.12661 6.79327 6.2858 6.61106 6.41536C6.40548 6.56154 6.16107 6.65555 5.67225 6.84356L2.66634 7.99967L5.67225 9.15579C6.16107 9.3438 6.40548 9.4378 6.61107 9.58399C6.79327 9.71355 6.95247 9.87274 7.08203 10.0549C7.22821 10.2605 7.32222 10.5049 7.51022 10.9938L8.66634 13.9997L9.82246 10.9938C10.0105 10.5049 10.1045 10.2605 10.2507 10.055C10.3802 9.87274 10.5394 9.71355 10.7216 9.58399C10.9272 9.4378 11.1716 9.3438 11.6604 9.15579L14.6663 7.99967L11.6604 6.84356C11.1716 6.65555 10.9272 6.56154 10.7216 6.41536C10.5394 6.2858 10.3802 6.12661 10.2507 5.9444C10.1045 5.73881 10.0105 5.4944 9.82246 5.00558L8.66634 1.99967Z", stroke: "white", "stroke-width": "1.33333", "stroke-linecap": "round", "stroke-linejoin": "round" })),
                        React.createElement("defs", null,
                            React.createElement("clipPath", { id: "clip0_6578_5962" },
                                React.createElement("rect", { width: "16", height: "16", fill: "white" }))))),
                React.createElement("h4", { className: styles.title }, "Auto retrieve your Bill Reports")),
            React.createElement("div", { className: styles.formContainer },
                React.createElement(Form, { change: setData, className: styles.body, data: data, errors: errors, buttons: false, input: [
                        {
                            label: "Who is your current network provider?",
                            name: "platform",
                            type: InputType.DropdownOptionsNew,
                            options: billingEngines,
                        },
                        {
                            label: "Username",
                            name: "username",
                            type: InputType.TextNew,
                            small: true,
                        },
                        {
                            label: "Password",
                            name: "password",
                            type: InputType.PasswordNew,
                            showPassword: true,
                            small: true,
                        },
                        {
                            label: "Does your login have 2FA?",
                            name: "twoFA",
                            type: InputType.SmallToggleNew,
                        },
                    ] }))),
        React.createElement("div", { className: styles.bottom },
            React.createElement(Button, { arrow: true, newCta: true, click: submitPlatform }, "CONNECT TO REPORTS"))));
}
export default Auto;
